export default {
  'driver-out': '司机已出发',
  'data-unavailable': '数据不可用',
  delivered: '已送达',
  'wrong-address': '地址错误',
  'not-present': '无人接收',
  'order-canceled': '订单已取消',
  'delivery-attempted': '尝试投递',
  rescheduled: '已重新安排',
  'date-unavailable': '日期不可用',
}
